'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//ng-if that does not create a new scope. Also, operates at higher priority than ng-repeat
_module3.default.directive('lightIfHighPriority', ['$animate', '$compile', function ($animate, $compile) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 10000,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attr, ctrl, $transclude) {
      var savedClone;
      $scope.$watch($attr.lightIfHighPriority, function lightIfHighPriorityWatchAction(value) {

        if (value) {
          if (!savedClone) {
            $transclude($scope, function (clone) {
              // Note: We only need the first/last node of the cloned nodes.
              // However, we need to keep the reference to the jqlite wrapper as it might be changed later
              // by a directive with templateUrl when its template arrives.
              savedClone = clone;
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        } else {
          if (savedClone) {
            $animate.leave(savedClone);
            savedClone = null;
          }
        }
      });
    }
  };
}]);


//////////////////
// WEBPACK FOOTER
// ./src/core/lightIfHighPriority.js
// module id = 47
// module chunks = 0 2